// OLD IMPORTS
//import React, { lazy, Suspense } from 'react';
// import { getComponentForType } from '../../utils/componentMapping';
// import Image from '../Image';
// import Switch from '../Switch';
import React, { Suspense, ComponentType } from 'react';
import { useVariant, VariantElements } from '../../context/VariantContext';
import type { Question as QuestionType } from '../../types/questionnaire';

interface Props {
  question: QuestionType;
  onChecked: (id: number) => void;
  onClickedCheckBox?: (id: number) => void;
}

const Question = ({ question, onChecked }: Props) => {
  const { getVariantElements } = useVariant();

  question.answers.forEach((answer) => {
    if (!answer.questions || answer.questions.length === 0) {
      answer.type = 'checkbox';
    }
  });
/*
  const CheckboxDefault = React.useMemo(() => lazy(() => import('../Checkbox')), []);
  const DropdownDefault = React.useMemo(() => lazy(() => import('../Dropdown')), []);
  const CheckboxImageDefault = React.useMemo(() => lazy(() => import('../CheckboxImage')), []);
  const CheckboxNew = React.useMemo(() => lazy(() => import('../CheckboxNew')), []);
  const DropdownNew = React.useMemo(() => lazy(() => import('../DropdownNew')), []);
  const CheckboxImageNew = React.useMemo(() => lazy(() => import('../CheckboxImageNew')), []);
*/
  const QuestionComponent = React.useMemo(
    (): ComponentType<any>|undefined => {
      const components = getVariantElements();
      // some magic to fool the type checker... we use components.hasOwnProperty to ensure the thing actually exists
      const key: keyof VariantElements = "question_" + (question.type ?? "") as Extract<keyof VariantElements, React.ComponentType<any>>;
      if( components.hasOwnProperty(key) ) {
        return components[key];
      }
      return undefined;
    },
    [question.type]
    /*
      getComponentForType(question.type ?? '', {
        CheckboxDefault,
        CheckboxNew,
        DropdownDefault,
        DropdownNew,
        CheckboxImageDefault,
        CheckboxImageNew,
        Image,
        Switch,
        isNewVariant,
      }),
    [question.type, CheckboxDefault, CheckboxNew, DropdownDefault, DropdownNew, CheckboxImageDefault, CheckboxImageNew],
    */
  );

  if (!QuestionComponent) return null;

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <QuestionComponent question={question} onChecked={onChecked} />
    </Suspense>
  );
};

export default Question;
